import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
} from "react-bootstrap";
import Select from "react-select";
import {
  Card,
  CardBody,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";

import {
  formLabelsTheme,
  iconError,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  validateDateFields,
  validatePost,
  getValueType
} from "../../utility";
import SVG from "react-inlinesvg";
import {
  toAbsoluteUrl,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
} from "../../modules/Auth/_redux/authRedux";

// MUI
import {
  ThemeProvider,
  TextField
} from "@material-ui/core";

import {
  resetData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectVehicleList,
  fetchReportingVehicleInfo,
  fetchReportingVehicleInfoDownload,
  selectReporting2,
  fetchUniqueVehicleList,
} from "./transactionLogSlice";
import { VehicleInformationTable } from "./VehicleInformationTable";

import { useStyles, useStylesReddit } from "../../utility";

import { ModalColorRadio } from "../modalfilter/ModalColorRadio";
import { ModalProductRadio } from "../modalfilter/ModalProductRadio";
import { ModalModelRadio } from "../modalfilter/ModalModelRadio";
import { ModalClientRadio } from "../report/ModalClientRadio";
import {
  fetchParameter,
  fetchParameter2,
} from "../businessParameter/businessParameterSlice";
import { Autocomplete } from "@material-ui/lab";
import { FormHelperText } from "@material-ui/core";
import { ModalPartiesRadio } from "../report/ModalPartiesRadio";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const VehicleInformationPage = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const data = useSelector(selectReporting2);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const vehicleList = useSelector(selectVehicleList);
  const paginationSet = useSelector(selectPagination);

  const [btnHideFilter, setBtnHideFilter] = useState(false);

  useEffect(() => {
    dispatch(resetData());
  }, [dispatch]);

  // Fungsi untuk mengubah nilai btnHide antara true dan false
  const toggleBtnHideFilter = () => {
    setBtnHideFilter(!btnHideFilter);
  };

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load
      await dispatch(
        fetchUniqueVehicleList({})
      );
      await dispatch(
        fetchParameter({
          paramgroup_code: "SERVICE_CLASS",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "JOB_TYPE",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  const [formValues, setFormValues] = useState({
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    receive_date_start: {
      value: "",
      error: false,
      required: "N",
    },
    receive_date_end: {
      value: "",
      error: false,
      required: "N",
    },
    inbound_type: {
      value: "",
      error: false,
      required: "N",
    },
    outbound_type: {
      value: "",
      error: false,
      required: "N",
    },
    vehicle_name: {
      value: "",
      error: false,
      required: "N",
    },
    vehicle_status: {
      value: [],
      error: false,
      required: "N",
    },
  });

  const handleSearch = async () => {
    if (!validatePost(formValues, setFormValues)) {
      return;
    }

    const dateFields = ["receive_date"];

    const dateValidationResult = validateDateFields(formValues, dateFields);
    if (dateValidationResult) {
      return showErrorDialog(dateValidationResult);
    }
    let params = {
      pageNo: 1,
      pageSize: paginationSet,
      client: formValues.client_name.value,
      start_receive_date: formValues.receive_date_start.value,
      end_receive_date: formValues.receive_date_end.value,
      vehicle_status: formValues.vehicle_status.value.join(','),
      vehicle_name: formValues.vehicle_name.value,
      inbound_type: formValues.inbound_type.value,
      outbound_type: formValues.outbound_type.value,
    };
    fields.forEach((item) => {
      params[item.params] = item.value;
    });

    try {
      const response = await dispatch(fetchReportingVehicleInfo(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {
        pageNo: page,
        pageSize: sizePerPage,
        client: formValues.client_name.value,
        start_receive_date: formValues.receive_date_start.value,
        end_receive_date: formValues.receive_date_end.value,
        vehicle_status: formValues.vehicle_status.value.join(','),
        vehicle_name: formValues.vehicle_name.value,
        inbound_type: formValues.inbound_type.value,
        outbound_type: formValues.outbound_type.value,
      };
      fields.forEach((item) => {
        params[item.params] = item.value;
      });

      try {
        const response = await dispatch(fetchReportingVehicleInfo(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const handleDownload = async () => {
    const dateFields = ["receive_date"];

    const dateValidationResult = validateDateFields(formValues, dateFields);
    if (dateValidationResult) {
      return showErrorDialog(dateValidationResult);
    }
    let params = {
      client: formValues.client_name.value,
      start_receive_date: formValues.receive_date_start.value,
      end_receive_date: formValues.receive_date_end.value,
      vehicle_status: formValues.vehicle_status.value.join(','),
      vehicle_name: formValues.vehicle_name.value,
      inbound_type: formValues.inbound_type.value,
      outbound_type: formValues.outbound_type.value,
    };
    fields.forEach((item) => {
      params[item.params] = item.value;
    });

    try {
      const response = await dispatch(
        fetchReportingVehicleInfoDownload(params)
      );
      if (response.payload.status === 200) {
        showSuccessDialog(response.payload.data.message);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const optionsStatus = [
    {
      label: "Confirmed",
      value: "Confirmed",
    },
    {
      label: "Initiated",
      value: "Initiated",
    },
    {
      label: "Canceled",
      value: "Canceled",
    },
  ];

  const optionsRFS = [
    {
      label: "Yes",
      value: "Y",
    },
    {
      label: "No",
      value: "N",
    },
  ];
  const optionsFinalHoldStatus = [
    {
      label: "Hold",
      value: "Hold",
    },
    {
      label: "Un-hold",
      value: "UnHold",
    },
  ];
  // Parameter
  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",
      value: "vin",
      label: "VINs",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "von",
      label: "VONs",
      show: "Y",
      editor: "text",
    },
    {
      id: "3",
      value: "inbound_job",
      label: "Inbound Job No.",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "model_code",
      label: "Model Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "model_name",
      label: "Model Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "color_code",
      label: "Color Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "color_name",
      label: "Color Name",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "engine_no",
      label: "Engine No",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "model_year",
      label: "Model year",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "location",
      label: "Location",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "parent_location",
      label: "Parent Location",
      show: "Y",
      editor: "text",
    },
    {
      id: "4",
      value: "rfs",
      label: "Ready For Sales",
      show: "Y",
      editor: "rfs",
    },
    {
      id: "5",
      value: "final_hold_status",
      label: "Final Hold Status",
      show: "Y",
      editor: "final_hold_status",
    },
  ]);

  // paket filter

  const [btnHide, setBtnHide] = useState(false);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      values[i].remove = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      const filteredShow = result.filter((item) => item.show === "Y");
      if (filteredShow.length <= 1) {
        setBtnHide(true);
      } else {
        setBtnHide(false);
      }

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      });
      setFields(values);
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });

    setTypeOptions(result);

    const filteredShow = result.filter((item) => item.show === "Y");
    if (filteredShow.length >= 1) {
      setBtnHide(false);
    } else {
      setBtnHide(true);
    }

    values.splice(i, 1);
    setFields(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    setFields(values);
  };

  // paket filter bawah

  // modal filter
  const [showModel, setShowModel] = useState(false);
  const [showColor, setShowColor] = useState(false);
  const [showProduct, setShowProduct] = useState(false);
  const [showClient, setShowClient] = useState(false);
  const [showParty, setShowParty] = useState(false);
  const [getData, setGetData] = useState(false);
  const [getDataClient, setGetDataClient] = useState(false);
  const [getDataDealer, setGetDataDealer] = useState(false);

  const [partyType, setPartyType] = useState(false);

  const handleSelectChange = (i, e) => {
    if (e === null) {
      e = undefined;
      const values = [...fields];
      values[i].value = "";
      setFields(values);
    } else {
      const values = [...fields];
      values[i].value = e.value;

      setFields(values);
    }
  };

  const [fieldsFilter, setFieldsFilter] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const optionsInboundType = [
    { label: "DOM", value: "DOM" },
    { label: "Import", value: "IMP" },
  ];

  const optionsOutboundType = [
    { label: "DOM", value: "DOM" },
    { label: "Export", value: "EXP" },
  ];

  const optionsStatusVehicle = [
    { label: "Ready For RCI", value: "070" },
    { label: "RCI OK", value: "150" },
    { label: "RCI NG", value: "117" },
    { label: "PDI-In OK", value: "160" },
    { label: "PDI-Out NG", value: "185" },
    { label: "PDI-Out OK", value: "190" },
    { label: "Storage OK, RFS OK", value: "480" },
    { label: "Booking Confirmed", value: "490" },
    { label: "Picking Confirmed", value: "710" },
    { label: "Handover Confirmed, MP-OUT", value: "760" },
  ];

  const optionsVehicleName = vehicleList ? vehicleList.map((e) => {
    return {
      value: e.product_description,
      label: e.product_description,
    };
  }) : [];

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div>
        <Card>
          <CardBody>
            <Button
              className="btn btn-primary my-btn-primary-dark text-bold mb-5"
              onClick={toggleBtnHideFilter}
            >
              <span
                className="svg-icon svg-icon-md svg-icon-light"
                style={{ marginRight: "0px" }}
              >
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/New/SearchParameter.svg"
                  )}
                  className="mr-2"
                />
              </span>
              Search Parameter
            </Button>
            {btnHideFilter === true && (
              <>
                <div className="mb-5">
                  <ThemeProvider theme={formLabelsTheme}>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              required
                              label="Client"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.client_name.value}
                              readOnly
                              error={formValues.client_name.error}
                              helperText={
                                formValues.client_name.error ? (
                                  <FormHelperText
                                    sx={{ mt: "5px", mb: "-10px" }}
                                  >
                                    {iconError} {"This field is required"}
                                  </FormHelperText>
                                ) : (
                                  ""
                                )
                              }
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <div>
                              <a className="display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                <span
                                  className="svg-icon svg-icon-md svg-icon-light"
                                  onClick={() => {
                                    setShowClient(true);
                                    setGetDataClient(true);
                                  }}
                                >
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/Search.svg"
                                    )}
                                  />
                                </span>
                              </a>
                            </div>
                          </Col>
                          {formValues.client_name.value !== "" && (
                            <Col xs={1} sm={1} md={1} lg={1}>
                              <div
                                style={{ marginTop: "22px", cursor: "pointer" }}
                                onClick={() => {
                                  setFormValues({
                                    ...formValues,

                                    ["client_name"]: {
                                      ...formValues["client_name"],
                                      value: "",
                                    },
                                  });
                                }}
                              >
                                <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/x-square.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            </Col>
                          )}
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <Autocomplete
                              disableCloseOnSelect
                              options={optionsInboundType}
                              getOptionLabel={(option) => `${option.label}`}
                              getOptionValue={(option) => option.value}
                              value={
                                optionsInboundType.find(
                                  (option) =>
                                    formValues.inbound_type.value !== null && option.value === formValues.inbound_type.value
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                if (newValue === null || newValue.length === 0) {
                                  setFormValues({
                                    ...formValues,
                                    ["inbound_type"]: {
                                      ...formValues["inbound_type"],
                                      value: "",
                                    },
                                  });
                                } else {
                                  setFormValues({
                                    ...formValues,
                                    ["inbound_type"]: {
                                      ...formValues["inbound_type"],
                                      value: newValue.value,
                                    },
                                  });
                                }
                              }}
                              renderInput={(params) => (
                                <RedditTextField
                                  className={classes.margin}
                                  {...params}
                                  label="Inbound"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  placeholder="Select"
                                  name="inbound_type"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <Autocomplete
                              disableCloseOnSelect
                              options={optionsOutboundType}
                              getOptionLabel={(option) => `${option.label}`}
                              getOptionValue={(option) => option.value}
                              value={
                                optionsOutboundType.find(
                                  (option) =>
                                    formValues.outbound_type.value !== null && option.value === formValues.outbound_type.value
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                if (newValue === null || newValue.length === 0) {
                                  setFormValues({
                                    ...formValues,
                                    ["outbound_type"]: {
                                      ...formValues["outbound_type"],
                                      value: "",
                                    },
                                  });
                                } else {
                                  setFormValues({
                                    ...formValues,
                                    ["outbound_type"]: {
                                      ...formValues["outbound_type"],
                                      value: newValue.value,
                                    },
                                  });
                                }
                              }}
                              renderInput={(params) => (
                                <RedditTextField
                                  className={classes.margin}
                                  {...params}
                                  label="Outbound"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  placeholder="Select"
                                  name="outbound_type"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <Autocomplete
                              disableCloseOnSelect
                              options={optionsVehicleName}
                              getOptionLabel={(option) => `${option.label}`}
                              getOptionValue={(option) => option.value}
                              value={
                                optionsVehicleName.find(
                                  (option) =>
                                    formValues.vehicle_name.value !== null && option.value === formValues.vehicle_name.value
                                ) || null
                              }
                              onChange={(event, newValue) => {
                                if (newValue === null || newValue.length === 0) {
                                  setFormValues({
                                    ...formValues,
                                    ["vehicle_name"]: {
                                      ...formValues["vehicle_name"],
                                      value: "",
                                    },
                                  });
                                } else {
                                  setFormValues({
                                    ...formValues,
                                    ["vehicle_name"]: {
                                      ...formValues["vehicle_name"],
                                      value: newValue.value,
                                    },
                                  });
                                }
                              }}
                              renderInput={(params) => (
                                <RedditTextField
                                  className={classes.margin}
                                  {...params}
                                  label="Vehicle Name"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  placeholder="Select"
                                  name="vehicle_name"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={12} sm={3} md={4} lg={4}>
                            <RedditTextField
                              label="Date From"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="datetime-local"
                              size="small"
                              name="receive_date_start"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.receive_date_start.value}
                            />
                          </Col>
                          <Col xs={1} sm={1} md={1} lg={1}>
                            <p className="text-center mt-5">To</p>
                          </Col>
                          <Col xs={12} sm={3} md={4} lg={4}>
                            <RedditTextField
                              label="Date Until"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              type="datetime-local"
                              size="small"
                              name="receive_date_end"
                              fullWidth
                              onChange={handleChange}
                              value={formValues.receive_date_end.value}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <Autocomplete
                              multiple
                              disableCloseOnSelect
                              options={optionsStatusVehicle}
                              getOptionLabel={(option) => `${option.label} (${option.value})`}
                              getOptionValue={(option) => option.value}
                              value={
                                optionsStatusVehicle.filter(
                                  (option) =>
                                    formValues.vehicle_status.value !== null && formValues.vehicle_status.value.includes(option.value)
                                ) || []
                              }
                              onChange={(event, newValue) => {
                                if (newValue === null || newValue.length === 0) {
                                  setFormValues({
                                    ...formValues,
                                    ["vehicle_status"]: {
                                      ...formValues["vehicle_status"],
                                      value: [],
                                    },
                                  });
                                } else {
                                  setFormValues({
                                    ...formValues,
                                    ["vehicle_status"]: {
                                      ...formValues["vehicle_status"],
                                      value: newValue.map(it => it.value),
                                    },
                                  });
                                }
                              }}
                              renderInput={(params) => (
                                <RedditTextField
                                  className={classes.margin}
                                  {...params}
                                  label="Vehicle Status"
                                  id="reddit-input"
                                  size="small"
                                  fullWidth
                                  placeholder="Select"
                                  name="vehicle_status"
                                />
                              )}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={12} md={12} lg={12}>
                        {fields.map((field, idx) => {
                          return (
                            <div key={`${field}-${idx}`}>
                              <Form.Group as={Row}>
                                <Form.Label column sm={2} className="ml-4 pr-0">
                                  {idx === 0 && <b>Advance Search</b>}
                                </Form.Label>

                                <Col sm={3} className="pl-0">
                                  {fields[idx].add === "N" && (
                                    <Select
                                      // isClearable={true}
                                      options={data_filter}
                                      value={getValueType(field.params, typeOptions)}
                                      placeholder="Select Field"
                                      // onChange={handleTypeChange}
                                      onChange={(e) => handleTypeChange(idx, e)}
                                    />
                                  )}
                                  {fields[idx].add === "Y" && (
                                    <Form.Control
                                      type="text"
                                      value={fields[idx].label}
                                      disabled
                                    />
                                  )}
                                </Col>
                                <Col sm={3}>
                                  {field.editor === "text" && (
                                    <Form.Control
                                      type="text"
                                      placeholder="Enter text"
                                      value={field.value || ""}
                                      onChange={(e) => handleRemarkChange(idx, e)}
                                    />
                                  )}
                                  {field.editor === "status" && (
                                    <Select
                                      isClearable={true}
                                      options={optionsStatus}
                                      value={getValueType(field.value, optionsStatus)}
                                      placeholder="Select Status"
                                      // onChange={handleTypeChange}
                                      onChange={(e) => handleSelectChange(idx, e)}
                                    />
                                  )}
                                  {field.editor === "rfs" && (
                                    <Select
                                      isClearable={true}
                                      options={optionsRFS}
                                      value={getValueType(field.value, optionsRFS)}
                                      placeholder="Select Status"
                                      // onChange={handleTypeChange}
                                      onChange={(e) => handleSelectChange(idx, e)}
                                    />
                                  )}
                                  {field.editor === "final_hold_status" && (
                                    <Select
                                      isClearable={true}
                                      options={optionsFinalHoldStatus}
                                      value={getValueType(field.value, optionsFinalHoldStatus)}
                                      placeholder="Select Status"
                                      // onChange={handleTypeChange}
                                      onChange={(e) => handleSelectChange(idx, e)}
                                    />
                                  )}
                                  {field.editor === "date" && (
                                    <Form.Control
                                      type="date"
                                      value={field.value || ""}
                                      onChange={(e) => handleRemarkChange(idx, e)}
                                    />
                                  )}
                                </Col>
                                <Col sm={3} className=" m-0 p-0">
                                  {field.params === "model_code" && (
                                    <div
                                      className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                                      onClick={() => {
                                        setShowModel(true);
                                        setGetData(true);
                                      }}
                                    >
                                      <span className="svg-icon svg-icon-md svg-icon-light">
                                        <SVG
                                          src={toAbsoluteUrl(
                                            "/media/svg/icons/New/Search.svg"
                                          )}
                                        />
                                      </span>
                                    </div>
                                  )}
                                  {field.params === "color_code" && (
                                    <div
                                      className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                                      onClick={() => {
                                        setShowColor(true);
                                        setGetData(true);
                                      }}
                                    >
                                      <span className="svg-icon svg-icon-md svg-icon-light">
                                        <SVG
                                          src={toAbsoluteUrl(
                                            "/media/svg/icons/New/Search.svg"
                                          )}
                                        />
                                      </span>
                                    </div>
                                  )}
                                  {field.params === "master_code" && (
                                    <div
                                      className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                                      onClick={() => {
                                        setShowProduct(true);
                                        setGetData(true);
                                      }}
                                    >
                                      <span className="svg-icon svg-icon-md svg-icon-light">
                                        <SVG
                                          src={toAbsoluteUrl(
                                            "/media/svg/icons/New/Search.svg"
                                          )}
                                        />
                                      </span>
                                    </div>
                                  )}
                                  {fields[idx].remove === "Y" && (
                                    <div
                                      className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                                      onClick={() => handleRemove(idx)}
                                    >
                                      <span className="svg-icon svg-icon-md svg-icon-light">
                                        <SVG
                                          src={toAbsoluteUrl("/media/svg/icons/New/X.svg")}
                                        />
                                      </span>
                                    </div>
                                  )}

                                  {btnHide === false && fields.length - 1 === idx && (
                                    <Button
                                      className="mr-3"
                                      variant="outline-primary"
                                      onClick={(e) => handleAdd(idx, e)}
                                    >
                                      Add
                                    </Button>
                                  )}
                                </Col>
                              </Form.Group>
                            </div>
                          );
                        })}
                      </Col>
                    </Row>
                  </ThemeProvider>
                </div>

                <Row className="mt-6 justify-content-end">
                  <Button className="mr-3" onClick={handleDownload}>
                    <span
                      className="svg-icon svg-icon-md svg-icon-light"
                      style={{ marginRight: "0px" }}
                    >
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/XLS.svg")}
                      />
                    </span>
                    Download
                  </Button>

                  <Button
                    className="mr-3 btn-filter"
                    variant="primary"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                </Row>
              </>
            )}

            <VehicleInformationTable
              data={data === null ? [] : data}
              page={pageNo}
              sizePerPage={pageSize}
              totalSize={totalRecord}
              onTableChange={handleTableChange}
              loading={loading}
              handleSearch={handleSearch}
            />
          </CardBody>
        </Card>
      </div>

      <ModalClientRadio
        isOpen={showClient}
        setShow={setShowClient}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getDataClient}
        setGetData={setGetDataClient}
      />

      <ModalModelRadio
        isOpen={showModel}
        setShow={setShowModel}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getData}
        setGetData={setGetData}
      />
      <ModalProductRadio
        isOpen={showProduct}
        setShow={setShowProduct}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getData}
        setGetData={setGetData}
      />
      <ModalColorRadio
        isOpen={showColor}
        setShow={setShowColor}
        setFormValues={setFields}
        formValues={fields}
        setFields={setFieldsFilter}
        fields={fieldsFilter}
        getData={getData}
        setGetData={setGetData}
      />

      <ModalPartiesRadio
        isOpen={showParty}
        setShow={setShowParty}
        setFormValues={setFormValues}
        formValues={formValues}
        setFields={setFields}
        fields={fields}
        getData={getDataDealer}
        setGetData={setGetDataDealer}
        partyType={partyType}
        setPartyType={setPartyType}
      />
    </>
  );
};
